import { renderDynamicApplyPage as renderPublishedApplicationPage } from './dynamicApplyBranding';

type FormConfigEnvelope = {
  ok?: boolean;
  data?: {
    form?: {
      template_name?: string;
      schema?: { fields?: unknown[] };
    };
  };
  error?: { message?: string; requestId?: string };
};

function safe(value: unknown): string {
  return String(value ?? '')
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#039;');
}

function renderPublicationError(root: HTMLElement, outlet: string, message: string): void {
  root.innerHTML = `
    <main class="page application-page">
      <section class="paper application-paper">
        <div class="masthead">
          <div>
            <div class="brand-cn">阿笨的猪堡店</div>
            <div class="brand-en">STUPIAK'S PORK BURGER</div>
          </div>
          <div class="title-lockup">
            <div class="form-title">Application unavailable</div>
            <div class="form-subtitle">${safe(outlet)}</div>
          </div>
        </div>
        <div class="dynamic-form-intro">
          <strong>The published application form for this outlet could not be loaded.</strong>
          <p>${safe(message)}</p>
          <p>Please refresh the page after the latest Cloudflare production deployment is complete.</p>
        </div>
      </section>
    </main>`;
}

export async function renderDynamicApplyPage(root: HTMLElement): Promise<void> {
  const params = new URLSearchParams(location.search);
  const explicitOutlet = String(params.get('outlet') || '').trim().toUpperCase();

  // The legacy all-outlet page remains available only when no outlet-specific
  // publication was requested. An explicit outlet must never silently fall
  // back to a different form.
  if (!explicitOutlet) {
    await renderPublishedApplicationPage(root);
    return;
  }

  root.innerHTML = '<main class="page application-page"><div class="paper application-paper"><div class="form-loading">Loading published application form…</div></div></main>';

  try {
    const response = await fetch(`/api/form-config?outlet=${encodeURIComponent(explicitOutlet)}`, {
      headers: { Accept: 'application/json' },
      cache: 'no-store',
    });
    const body = await response.json() as FormConfigEnvelope;
    const fields = body.data?.form?.schema?.fields;
    if (!response.ok || !body.ok || !Array.isArray(fields) || !fields.length) {
      renderPublicationError(
        root,
        explicitOutlet,
        body.error?.message || `No active application publication was returned for ${explicitOutlet}.`,
      );
      return;
    }
  } catch (error) {
    renderPublicationError(
      root,
      explicitOutlet,
      error instanceof Error ? error.message : String(error),
    );
    return;
  }

  await renderPublishedApplicationPage(root);
}
